"use client";

import { TopBar, TopNavBar, Footer } from '@/layout';
import FeaturedHoliday from '../services/hotels/components/FeaturedHoliday';
import Hero from './components/Hero';
import DestinationsOverview from './components/DestinationsOverview';
import HotelsExcursionsPromo from './components/HotelsExcursionsPromo';
import { useEastCretePage, getSectionByKey } from '@/hooks/useEastCretePage';
import { Spinner } from 'react-bootstrap';

const EastCrete = ({ initialSections = null }) => {
  const { sections, loading, error } = useEastCretePage(null, initialSections);

  const featuredHolidaySection =
    !loading && !error ? getSectionByKey(sections, 'featured_holiday') : null;
  const footerTrustindexScripts = featuredHolidaySection?.content?.embed_scripts;

  if (loading) {
    return (
      <>
        <TopBar />
        <TopNavBar />
        <main>
          <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '50vh' }}>
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        </main>
        <Footer footerEmbedScripts={footerTrustindexScripts} />
      </>
    );
  }

  if (error) {
    return (
      <>
        <TopBar />
        <TopNavBar />
        <main>
          <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '50vh' }}>
            <p className="text-danger">Error loading East Crete page: {error}</p>
          </div>
        </main>
        <Footer footerEmbedScripts={footerTrustindexScripts} />
      </>
    );
  }

  const destinationsOverviewSection = getSectionByKey(sections, 'destinations_overview');
  const hotelsExcursionsPromoSection = getSectionByKey(sections, 'hotels_excursions_promo');
  const heroSection = getSectionByKey(sections, 'hero');

  return (
    <>
      <TopBar />
      <TopNavBar />
      <main>
        {featuredHolidaySection && <FeaturedHoliday sectionData={featuredHolidaySection} />}
        <DestinationsOverview sectionData={destinationsOverviewSection} />
        {hotelsExcursionsPromoSection && <HotelsExcursionsPromo sectionData={hotelsExcursionsPromoSection} />}
        {heroSection && <Hero sectionData={heroSection} />}
      </main>
      <Footer footerEmbedScripts={footerTrustindexScripts} />
    </>
  );
};

export default EastCrete;
